import React from 'react'
import { DirectDepositInfo } from './direct_deposit_info/direct_deposit_info'
import { Field, connect } from 'formik'
import { FiscalYearChangeNotice } from './fiscal_year_change_notice/fiscal_year_change_notice'
import { FormRadio } from 'shared'
import { FormValues } from 'donate/types'

export const PaymentMethodSelection = connect<{}, FormValues>(({ formik }) => {
  const isRecurring = formik.values.interval !== 'single'

  return (
    <div className="donation-form-payment-method-links mb-3">
      <h4>{i18n.t('donate.payment_method.headline')}</h4>
      <div className="payment-method-radios form-group">
        {formik.values._payment_methods.map((name: string) => {
          const isBrowserUnsupported = name === 'paypal' && /Twitter/i.test(navigator.userAgent)
          const isRecurringUnsupported = isRecurring && !formik.values._recurring_payment_methods.includes(name)

          return (
            <Field
              key={name}
              name="payment_method"
              component={FormRadio}
              value={name}
              label={i18n.t(`donate.payment_method.labels.${name}`)}
              className="payment-method-radio cursor-pointer"
              disabled={isBrowserUnsupported || isRecurringUnsupported}
              disabledInfo={
                isBrowserUnsupported
                  ? i18n.t('donate.errors.paypal_unsupported_browser')
                  : isRecurringUnsupported
                    ? i18n.t('donate.recurring_disabled_popover')
                    : null
              }
            />
          )
        })}
      </div>
      <DirectDepositInfo paymentMethod={formik.values.payment_method} />
      <FiscalYearChangeNotice paymentMethod={formik.values.payment_method} />
    </div>
  )
})
